<template>
  <div>
    <iframe width="100%" height="" :src="src" frameborder="0" allowfullscreen="yes" ></iframe>
  </div>
</template>

<script>

export default {
  props: [
    'src'
  ]
}

</script>
